@if(mode==='read'){
<div>
    <div nz-row>
        <div nz-col nzSpan="8">Address Line 1</div>
        <div nz-col nzSpan="16">{{ data?.street1}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">Address Line 2</div>
        <div nz-col nzSpan="16">{{ data?.street2}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">City</div>
        <div nz-col nzSpan="16">{{ data?.city}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">State</div>
        <div nz-col nzSpan="16">{{ data?.state}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">Zip Code</div>
        <div nz-col nzSpan="16">{{ data?.zipCode}}</div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="8">County</div>
        <div nz-col nzSpan="16">{{ data?.countyOrRegion}}</div>
    </div>
    @if(is_permanent){
    <div nz-row style="margin-top:8px">
        <div nz-col nzSpan="11" class="ppl-read-label" style="margin-right:8px">Is the Mailing address the same as the Physical Address?</div>
        <div nz-col nzSpan="12">{{data?.mailing? "Yes" : "No"}}</div>
    </div>
    }
</div>
}
@else{
<div nz-row style="margin-top:8px;margin-bottom:25px">
    <div nz-col nzSpan="8" [nzSm]="8" [nzXs]="24" style="font-weight: 600;">
        Search Address
      </div>
      <div nz-col nzSpan="16">
        <p-autoComplete
          [(ngModel)]="selectedValue"
          [suggestions]="listOfOptions"
          field="text"
          [placeholder]="'Type your address'"
          [dropdown]="false"
          [forceSelection]="true"
          (completeMethod)="onSearch($event.query)"
          (onSelect)="validateAddress($event.value.value)"
          [inputId]="'searchAddressInput'"
          ariaLabel="Search {{ is_permanent ? 'Physical' : 'Mailing' }} Address, type address and then select value from dropdown">
        </p-autoComplete>
      </div>
    <!-- <div nz-col nzSpan="8" [nzSm]="8" [nzXs]="24" style="font-weight: 600;">Search Address</div>
    <div nz-col nzSpan="16">
        <nz-select 
            nzShowSearch 
            nzServerSearch 
            nzPlaceHolder="Type your address" 
            [(ngModel)]="selectedValue"
            [nzShowArrow]="false" 
            [nzFilterOption]="nzFilterOptions" 
            (nzOnSearch)="onSearch($event)"
            (ngModelChange)="validateAddress($event)"
            pplNzAriaLabel
            [nzAriaLabel]="'Search ' + (is_permanent ? 'Physical' : 'Mailing') + ' Address, type address and then select value from dropdown'">
            @for(option of listOfOptions; track $index){
            <nz-option [nzValue]="option.value" [nzLabel]="option.text"></nz-option>
            }
        </nz-select>
    </div> -->
</div>
<div [formGroup]="addressForm">
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" [nzFor]="(is_permanent ? 'permanent' : 'mailing') + '-street1'" class="ppl-form-label">Address Line 1<span [attr.aria-label]="'Required'">*</span></nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input [ngClass]="{'error': (permanentValidationErrors['street1'] || mailingValidationErrors['street1']) }"
            [attr.aria-invalid]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1']) ? 'true' : 'false'"
            [attr.aria-describedby]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1']) ? 'street1-error' : null" 
            aria-autocomplete="none" nz-input formControlName="street1" [id]="(is_permanent ? 'permanent' : 'mailing') + '-street1'" />
            @if (permanentValidationErrors['street1'] || mailingValidationErrors['street1']) {
                <span id="street1-error" class="pl-1 error-message" role="alert">{{(permanentValidationErrors['street1'] || mailingValidationErrors['street1'])}}</span>
              }
        </nz-form-control>
       
        
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" [nzFor]="(is_permanent ? 'permanent' : 'mailing') + '-street2'" class="ppl-form-label">Address Line 2</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input nz-input formControlName="street2" aria-autocomplete="none" [id]="(is_permanent ? 'permanent' : 'mailing') + '-street2'" />
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" [nzFor]="(is_permanent ? 'permanent' : 'mailing') + '-city'" class="ppl-form-label">City  <span [attr.aria-label]="'Required'">*</span></nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input [ngClass]="{'error': (permanentValidationErrors['city'] || mailingValidationErrors['city']) }"
            [attr.aria-invalid]="(permanentValidationErrors['city'] || mailingValidationErrors['city']) ? 'true' : 'false'"
            [attr.aria-describedby]="(permanentValidationErrors['city'] || mailingValidationErrors['city']) ? 'city-error' : null"
            nz-input formControlName="city" [id]="(is_permanent ? 'permanent' : 'mailing') + '-city'" />
            @if (permanentValidationErrors['city'] || mailingValidationErrors['city']) {
                <span id="city-error" class="pl-1 error-message" role="alert">{{(permanentValidationErrors['city'] ||  mailingValidationErrors['city'])}}</span>
              }
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" [nzFor]="(is_permanent ? 'permanent' : 'mailing') + '-state'" 
        class="ppl-form-label">State  <span [attr.aria-label]="'Required'">*</span></nz-form-label>
        <nz-form-control class="ppl-form-control">
            <!-- <nz-select formControlName="state" class="ppl-select" [nzId]="(is_permanent ? 'permanent' : 'mailing') + '-state'" nzShowSearch nzAllowClear
                [ngClass]="{'error': permanentValidationErrors['state'] || mailingValidationErrors['state'] }"
                [attr.aria-invalid]="(permanentValidationErrors['state'] || mailingValidationErrors['state']) ? 'true' : 'false'"
    [attr.aria-describedby]="(permanentValidationErrors['state'] || mailingValidationErrors['state']) ? 'state-error' : null">
                @for(opt of statesListDropdown; track $index){
                    <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                }
            </nz-select> -->
            <div>
                <div class="ppl-select" [ngClass]="{'error': permanentValidationErrors['state'] || mailingValidationErrors['state'] }">
                  <ppl-dropdown-select formControlName="state" [id]="(is_permanent ? 'permanent' : 'mailing') + '-state'"
                    [options]="statesListDropdown" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                    [arialabel]="'State, required'"
                    [attr.aria-invalid]="(permanentValidationErrors['state'] || mailingValidationErrors['state']) ? 'true' : 'false'"
                    [attr.aria-describedby]="(permanentValidationErrors['state'] || mailingValidationErrors['state']) ? 'state-error' : null">
                </ppl-dropdown-select>
                </div>
              </div>
            <!-- <input [ngClass]="{'error': (permanentValidationErrors['state'] || mailingValidationErrors['state'])  }" nz-input formControlName="state" id="state" /> -->
            @if (permanentValidationErrors['state'] || mailingValidationErrors['state']) {
                <span id="state-error" class="pl-1 error-message" role="alert">{{(permanentValidationErrors['state'] || mailingValidationErrors['state'])}}</span>
              }
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" [nzFor]="(is_permanent ? 'permanent' : 'mailing') + '-zipCode'" class="ppl-form-label">Zip Code  <span [attr.aria-label]="'Required'">*</span></nz-form-label>
        <nz-form-control class="ppl-form-control">
            <input [ngClass]="{'error': (permanentValidationErrors['zipCode'] || mailingValidationErrors['zipCode'])  }"
            [attr.aria-invalid]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1']) ? 'true' : 'false'"
            [attr.aria-describedby]="(permanentValidationErrors['street1'] || mailingValidationErrors['street1']) ? 'street1-error' : null" 
            aria-autocomplete="none" nz-input formControlName="zipCode" [id]="(is_permanent ? 'permanent' : 'mailing') + '-zipCode'" />
            @if (permanentValidationErrors['zipCode'] || mailingValidationErrors['zipCode']) {
                <span id="street1-error" class="pl-1 error-message" role="alert">{{permanentValidationErrors['zipCode'] || mailingValidationErrors['zipCode']}}</span>
              }
        </nz-form-control>
    </nz-form-item>
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" [nzFor]="(is_permanent ? 'permanent' : 'mailing') + '-countyOrRegion'" class="ppl-form-label">County @if(isCountyRequired){<span [attr.aria-label]="'Required'">*</span>}</nz-form-label>
        <nz-form-control class="ppl-form-control">

            @if(counties().length > 0 && isConsumerFlow) {
                <nz-select pplNzAriaLabel nzAriaLabel="County or Region, required" formControlName="countyOrRegion" class="ppl-select"
                 [nzId]="(is_permanent ? 'permanent' : 'mailing') + '-countyOrRegion'"
                nzPlaceHolder="Select County" [nzStatus]="(permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion']) ? 'error' : ''"
                [nzOptionOverflowSize]="4" [nzShowSearch]="true"
                [attr.aria-invalid]="(permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion']) ? 'true' : 'false'"
      [attr.aria-describedby]="(permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion']) ? 'countyOrRegion-error' : null">
                @for(county of counties(); track $index){
                <nz-option [nzLabel]="county.regionCountyName" [nzValue]="county.regionCountyName"></nz-option>
                }
              </nz-select>
            } @else {
                <input  [ngClass]="{'error': (permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion']) }"
                [attr.aria-invalid]="(permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion']) ? 'true' : 'false'"
      [attr.aria-describedby]="(permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion']) ? 'countyOrRegion-error' : null" nz-input formControlName="countyOrRegion" [id]="(is_permanent ? 'permanent' : 'mailing') + '-countyOrRegion'"
       aria-label="County or Region, required"/>
            }

            @if (permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion']) {
                <span id="countyOrRegion-error" class="pl-1 error-message" role="alert">{{permanentValidationErrors['countyOrRegion'] || mailingValidationErrors['countyOrRegion'] }}</span>
              }
        </nz-form-control>
    </nz-form-item>
    @if(fullAddress && fullAddress.length > 0){
        <div nz-row style="margin-top:8px;margin-bottom:25px">
            <div nz-col nzSpan="8" [nzSm]="8" [nzXs]="24" style="font-weight: 600;"></div>
            <div nz-col nzSpan="6"
            style="border: 1px solid #ddd; padding: 5px 10px;border-radius: 5px;" tabindex="0" aria-labelledby="fullAddressLabel fullAddressValue">
                <span id="fullAddressLabel" class="sr-only">Full Address:</span>
                <span id="fullAddressValue">{{fullAddress}}</span>
              </div>
        </div>
    }
    @if(is_permanent){
    <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="14" [nzXs]="24" nzFor="mailing" class="ppl-form-label">Is the Mailing address the same
            as the Physical Address?</nz-form-label>
        <nz-form-control class="ppl-form-control">
            <nz-switch 
                nzId="mailing" 
                formControlName="mailing"
                pplNzAriaLabel
                [attr.role]="'switch'"
                [attr.aria-checked]="addressForm.get('mailing')?.value ? 'true' : 'false'"
                nzAriaLabel="Is the Mailing address the same as the Physical Address"></nz-switch>
        </nz-form-control>
    </nz-form-item>
    }
</div>
}